import { LoginModal } from "../components/auth/loginModal";
import { useAuth } from "../context/authProvider";

const ProtectedRoute = ({ children }) => {
    const { isLoggedIn } = useAuth();
    if (isLoggedIn === null) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-white">
          <div className="h-6 w-6 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#008f36]" />
        </div>
      );
    }
  return isLoggedIn ? children : <LoginModal navigate="/" />;
};

export default ProtectedRoute;
